import { render, staticRenderFns } from "./AscParameterAlertItem.vue?vue&type=template&id=0189bdf9&"
import script from "./AscParameterAlertItem.vue?vue&type=script&lang=js&"
export * from "./AscParameterAlertItem.vue?vue&type=script&lang=js&"
import style0 from "./AscParameterAlertItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports